var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogVisible,
            direction: _vm.direction,
            size: "1000px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "detailHead" }, [
                _c("div", { staticClass: "full" }, [
                  _c("div", { staticClass: "order_icon" }, [
                    _c("span", { staticClass: "iconfont icon-dingdan" }),
                  ]),
                  _c("div", { staticClass: "text" }, [
                    _c(
                      "div",
                      { staticClass: "title" },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.activityInfo.groupName)),
                        ]),
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              effect: "plain",
                              type:
                                _vm.activityInfo.groupProcess == 0
                                  ? "success"
                                  : _vm.activityInfo.groupProcess == 1
                                  ? "warning"
                                  : "info",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.groupProcessArr[
                                  _vm.activityInfo.groupProcess
                                ]
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("div", [
                      _c("span", { staticClass: "mr20" }, [
                        _vm._v(
                          _vm._s(
                            _vm.activityInfo.startTime +
                              "至" +
                              _vm.activityInfo.endTime
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    [
                      _vm.activityInfo.groupStatus == 4
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.close(_vm.activityInfo.id)
                                },
                              },
                            },
                            [_vm._v("强制关闭")]
                          )
                        : _vm._e(),
                      _vm.activityInfo.groupStatus == 3
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.refuse(_vm.activityInfo.id)
                                },
                              },
                            },
                            [_vm._v("审核拒绝")]
                          )
                        : _vm._e(),
                      _vm.activityInfo.groupStatus == 3
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.pass(_vm.activityInfo.id)
                                },
                              },
                            },
                            [_vm._v("审核通过")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _c("ul", { staticClass: "list" }, [
                  _c("li", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("审核状态")]),
                    _c("div", { staticClass: "color-warning" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.groupStatusArr[_vm.activityInfo.groupStatus]
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("li", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("开团数")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.activityInfo.totalActivityBegin)),
                    ]),
                  ]),
                  _c("li", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("成团数")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.activityInfo.totalActivityDone)),
                    ]),
                  ]),
                  _c("li", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("参团订单数")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.activityInfo.totalOrderBegin)),
                    ]),
                  ]),
                  _c("li", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("成团订单数")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.activityInfo.totalOrderDone)),
                    ]),
                  ]),
                ]),
              ]),
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "活动信息", name: "detail" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "detailSection",
                          staticStyle: { border: "none" },
                        },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("基础信息"),
                          ]),
                          _c("ul", { staticClass: "list" }, [
                            _c("li", { staticClass: "item" }, [
                              _c("div", { staticClass: "tips" }, [
                                _vm._v("活动标签："),
                              ]),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(_vm.activityInfo.buyCount) + "人团"
                                ),
                              ]),
                            ]),
                            _c("li", { staticClass: "item" }, [
                              _c("div", { staticClass: "tips" }, [
                                _vm._v("成团人数："),
                              ]),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.activityInfo.buyCount)),
                              ]),
                            ]),
                            _c("li", { staticClass: "item" }, [
                              _c("div", { staticClass: "tips" }, [
                                _vm._v("成团有效期："),
                              ]),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(_vm.activityInfo.validHour) + "小时"
                                ),
                              ]),
                            ]),
                            _c("li", { staticClass: "item" }, [
                              _c("div", { staticClass: "tips" }, [
                                _vm._v("活动限购："),
                              ]),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.activityInfo.allQuota == -1
                                      ? "不限"
                                      : _vm.activityInfo.allQuota
                                  )
                                ),
                              ]),
                            ]),
                            _c("li", { staticClass: "item" }, [
                              _c("div", { staticClass: "tips" }, [
                                _vm._v("单次限购："),
                              ]),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.activityInfo.oncQuota == -1
                                      ? "不限"
                                      : _vm.activityInfo.oncQuota
                                  )
                                ),
                              ]),
                            ]),
                            _c("li", { staticClass: "item" }, [
                              _c("div", { staticClass: "tips" }, [
                                _vm._v("创建商户："),
                              ]),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.activityInfo.merName)),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "detailSection" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("高级设置"),
                        ]),
                        _c("ul", { staticClass: "list" }, [
                          _c("li", { staticClass: "item" }, [
                            _c("div", { staticClass: "tips" }, [
                              _vm._v("凑团："),
                            ]),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.activityInfo.showGroup == 0
                                    ? "关闭"
                                    : "开启"
                                )
                              ),
                            ]),
                          ]),
                          _c("li", { staticClass: "item" }, [
                            _c("div", { staticClass: "tips" }, [
                              _vm._v("虚拟成团："),
                            ]),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.activityInfo.fictiStatus == 0
                                    ? "关闭"
                                    : "开启"
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "商品信息", name: "goods" } },
                    [
                      _c(
                        "div",
                        _vm._l(
                          _vm.activityInfo.groupBuyActivityProductResponseList,
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "table-box" },
                              [
                                _c("div", { staticClass: "detailHead" }, [
                                  _c("div", { staticClass: "full" }, [
                                    _c("i", {
                                      staticClass: "iconfont iconChange",
                                      class: item.visible
                                        ? "icon-xuanze"
                                        : "icon-xiala1",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openClose(item)
                                        },
                                      },
                                    }),
                                    _c("img", {
                                      attrs: { src: item.image, alt: "" },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "text table-text" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "title line1",
                                            attrs: { title: item.productName },
                                          },
                                          [_vm._v(_vm._s(item.productName))]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                !item.groupBuyActivitySkuResponses.length
                                  ? _c(
                                      "div",
                                      { staticClass: "tablelHead text-title" },
                                      [
                                        _vm._v(
                                          " 该商品已下架，无法进行拼团购买！ "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                item.groupBuyActivitySkuResponses.length
                                  ? _c(
                                      "div",
                                      { staticClass: "tablelHead" },
                                      [
                                        !item.visible
                                          ? _c(
                                              "el-table",
                                              {
                                                staticClass: "orderDetailList",
                                                attrs: {
                                                  data: item.groupBuyActivitySkuResponses,
                                                  size: "small",
                                                },
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: { label: "图片" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c("img", {
                                                              attrs: {
                                                                src: scope.row[
                                                                  "attrValue"
                                                                ][0].image,
                                                                alt: "",
                                                              },
                                                            }),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "规格",
                                                    prop: "sku",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row[
                                                                    "attrValue"
                                                                  ][0].sku
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "商品编码",
                                                    prop: "barCode",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row[
                                                                    "attrValue"
                                                                  ][0]
                                                                    .barCode ||
                                                                    "--"
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "售价（元）",
                                                    prop: "price",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row[
                                                                    "attrValue"
                                                                  ][0].price
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "剩余库存",
                                                    prop: "stock",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row[
                                                                    "attrValue"
                                                                  ][0].stock
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "拼团价（元）",
                                                    prop: "activePrice",
                                                  },
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "拼团限量",
                                                    prop: "quota",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }